const createFileName = (name: string): string => {
  return `${name}__DocumentCrunch_${new Date()
    .toISOString()
    .slice(0, 19)
    .replace(/[-:T]/gm, '')}.pdf`
}

export const downloadPdf = (data: Blob, crunchLabel: string) => {
  if (!window) return
  try {
    const fileURL = window.URL.createObjectURL(data)
    const alink = document.createElement('a')
    alink.href = fileURL
    alink.download = createFileName(crunchLabel)
    alink.click()
  } catch (e) {
    console.error('Download PDF', e)
  }
}
